import * as React from 'react';

import { PrimitiveAtom, useAtom } from 'jotai';

import { PaywallTouchEventAdapter } from '~analytics/adapters/PaywallTouchEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { Dialog, DialogTitle } from '~shared/components/Dialog';
import { Inline } from '~shared/components/Inline';
import { Stack } from '~shared/components/Stack';
import { PaywallUpgradeButton } from '~teacher/components/PaywallDialog/PaywallUpgradeButton';

interface QuizEditorFileUploadPaywallProps {
  id: string;
  title: string;
  description: string;
  paywallScreen: PaywallScreens;
  paywallAtom: PrimitiveAtom<boolean>;
}

export function QuizEditorFileUploadPaywall({
  id,
  title,
  description,
  paywallScreen,
  paywallAtom,
}: QuizEditorFileUploadPaywallProps) {
  const [isOpen, setIsOpen] = useAtom(paywallAtom);

  React.useEffect(() => {
    if (isOpen) {
      new PaywallTouchEventAdapter(paywallScreen).sendAnalytics();
    }
  }, [isOpen, paywallScreen]);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      id={id}
      title={translate(title)}
      padding="confirmation"
      open={isOpen}
      onClose={handleClose}
      closeLabel={translate('Close')}
    >
      {(headerProps) => (
        <Stack space="8">
          <h3 className="m-0">
            <div className="text-center">
              <DialogTitle ref={headerProps.headingRef}>
                {headerProps.title}
              </DialogTitle>
            </div>
          </h3>
          <div className="font-sans text-center text-sm leading-8 text-blue-900">
            {translate(description)}
          </div>
          <Inline align="center">
            <UIButton key="cancel" onClick={handleClose}>
              {translate('Cancel')}
            </UIButton>
            <PaywallUpgradeButton
              key="upgrade"
              appearance="primary"
              paywallScreen={paywallScreen}
            />
          </Inline>
        </Stack>
      )}
    </Dialog>
  );
}
